export enum connectionEnum {
    connected="connected",
    connecting="connecting",
    reconnecting="reconnecting",
    disconnected="disconnected"
}